import type React from 'react';

/**
 * Render a tabs body.
 */
export function BlockTabsBody(props: { children: React.ReactNode }): React.ReactElement {
    const { children } = props;

    return (
        <div className="rounded rounded-tl-none border bg-base pr-4 pl-8 print:border-none print:p-0">
            {children}
        </div>
    );
}
